var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "#4D4D4D",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.54166,
    y: 8.0835,
    width: 0.766019,
    height: 16.0864,
    rx: 0.38301,
    transform: "rotate(-45 7.54166 8.0835)",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.766019
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.916,
    y: 7.54215,
    width: 0.766019,
    height: 16.0864,
    rx: 0.38301,
    transform: "rotate(45 18.916 7.54215)",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.766019
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.18e2d9c7d20a836347ad9cbf2e2cd59f.svg";
export { ForwardRef as ReactComponent };